import { Files } from '../../../lib/constants/files'
import { TeachingHall } from '../../../lib/types/models/ol/teaching-hall/teaching-hall'
import { TeachingHallInput } from '../../../lib/types/models/ol/teaching-hall/teaching-hall-input'
import { UpdateInput } from '../../../lib/types/utils'
import { uploadFile } from '../../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const updateTeachingHall = async (
  data: UpdateInput<TeachingHallInput> & { olId: number }
) => {
  const { id, olId, ...rest } = data
  if (rest.files)
    for (let i = 0; i < rest.files.length; i++) {
      const newFile = await uploadFile(Files.TEACHING_HALL, rest.files[i])
      if (newFile) rest.files[i] = { ...newFile }
    }

  return restApiClient
    .url(constructApiUrl(API.ols.updateTeachingHall.url, { id, olId }))
    .patch<TeachingHall, Partial<TeachingHallInput>>(rest)
}
